/**
 * Created by andrey on 22.07.2020
 */

var AppleSocial = function () {
    Social.call(this, connector.APPLE);
};

AppleSocial.prototype = Object.create(Social.prototype);
AppleSocial.prototype.constructor = AppleSocial;

AppleSocial.prototype.invalidateAccessToken = function () {
    this.id = "";
    this.token = "";

    this.save();
};

AppleSocial.prototype.updateNameFromServer = function (callback) {
    console.log("AppleSocial.updateNameFromServer");

    ConnectorRestClient.get("/info/name/" + connector.platform.getUserID(), {}, function (response) {
        var name = response.name || "";

        console.log("AppleSocial.updateNameFromServer success - " + name);

        this.name = name;
        this.save();

        callback(connector.STATUS_CONNECTED);
    }.bind(this), function (response) {
        console.log("AppleSocial.updateNameFromServer failure - " + response);

        callback(connector.STATUS_CONNECTED);
    });
};

AppleSocial.prototype.onAuthDetails = function (authDetails, callback) {
    console.log("AppleSocial.prepareData - " + JSON.stringify(authDetails));

    this.id = authDetails.id || "";
    this.token = authDetails.token || "";
    if (authDetails.name) {
        this.name = authDetails.name;
    }

    this.save();

    if (this.id && !this.name) {
        this.updateNameFromServer(callback);
    } else {
        callback(connector.STATUS_CONNECTED);
    }
};

AppleSocial.prototype.save = function () {
    connector.dataLoader.save(SimpleDataLoader.TYPES.APPLE_SOCIAL, {
        id: this.id,
        token: this.token,
        name: this.name
    });
};

AppleSocial.prototype._connect = function (callback) {
    var data = connector.dataLoader.load(SimpleDataLoader.TYPES.APPLE_SOCIAL);

    connector.platform.callNative("AppleSocialPlugin.init", { data: data }, function (code, authDetails) {
        this.onAuthDetails(authDetails, callback);
    }.bind(this));
};

AppleSocial.prototype.isLoggedIn = function () {
    return this._getUserID() && this.getAccessToken();
};

AppleSocial.prototype._getUserID = function () {
    if (this.id) {
        return "apple_" + this.id;
    }
};

AppleSocial.isAppleUserId = function (id) {
    return id && id.indexOf("apple_") === 0;
};

AppleSocial.prototype.getAccessToken = function () {
    return this.token;
};

AppleSocial.prototype._login = function (callback) {
    connector.platform.callNative("AppleSocialPlugin.login", function (code, authDetails) {
        this.onAuthDetails(authDetails, callback);
    }.bind(this));
};

AppleSocial.prototype._aboutMe = function (callback) {
    var data = {
        id: connector.platform.getUserID(),
        name: this.name
    };

    console.log("AppleSocial.aboutMe - " + JSON.stringify(data));

    callback(connector.CODE_SUCCEED, data);
};

AppleSocial.isAvailable = function () {
    return connector.platform.getPlugin().appleSocialAvailable && connector.platform.oneOf(connector.IOS, connector.MACOS);
};
